import { List, Divider } from 'antd';
import React, { useEffect, useState } from 'react';
import { getAllMensagemAContratar, MesnagemAContratar } from '@app/api/crf/crfAContratar';

interface ListMensagemProps {
    crfContaContabilCcId: string;
    recarregarMensagem: boolean;
}


const ListMensagem = (props: ListMensagemProps) => {
    const { crfContaContabilCcId, recarregarMensagem } = props
    const [mensgem, setMensagem] = useState<MesnagemAContratar[]>();


    useEffect(() => {
        carregarMensagem();
    }, [recarregarMensagem, crfContaContabilCcId]);

    const carregarMensagem = async () => {
        const mensagem = await getAllMensagemAContratar(crfContaContabilCcId);
        if (mensagem) {
            setMensagem(mensagem);
        }
    }

    return (
        <div>
            <List
                itemLayout="horizontal"
                dataSource={mensgem || []}
                renderItem={item => (
                    <List.Item>
                        <List.Item.Meta
                            title={
                                <a href="#">
                                    {item.nomeUsuario + ' - ' + item.dataHoraInclusao}
                                </a>
                            }
                            description={
                                <div>
                                    {item.mensagem}
                                    <Divider />
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />
        </div>
    );
}

export default ListMensagem;

